import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isShow: true,
    navList:[],
    navClass:0,
    showWorksList:0,
    headerNew:0,
    employList:[],
    employList1:[],
    employList2:[],
    employList3:[],
    employList4:[],
    employList5:[],
    employList6:[],
    employList7:[],
    employId:0,
    employPage:0,
    activicyList:[],
    activityPage:0
  },
  getters: {
  },
  mutations: {
    showData(state, data) {
      state.isShow = data;
    },
    navData(state, data){
      state.navList = data
    },
    navClasss(state, data){
      state.navClass = data
    },
    showWorks(state, data){
      state.showWorksList = data
    },
    headerActive(state, data){
      state.headerNew = data
    },
    employArray0(state, data){
      state.employList = data
    },
    employArray1(state, data){
      state.employList1 = data
    },
    employArray2(state, data){
      state.employList2 = data
    },
    employArray3(state, data){
      state.employList3 = data
    },
    employArray4(state, data){
      state.employList4 = data
    },
    employArray5(state, data){
      state.employList5 = data
    },
    employArray6(state, data){
      state.employList6 = data
    },
    employArray7(state, data){
      state.employList7 = data
    },
    employNav(state, data){
      state.employId = data
    },
    employPages(state, data){
      state.employPage = data
    },
    activicyArray(state, data){
      state.activicyList = data
    },
    activityPages(state, data){
      state.activityPage = data
    },
  },
  actions: {
  },
  modules: {
  }
})
